import { Observable } from 'rxjs';
import { StateApiData } from '../models/State.model';

export abstract class StateRepository {
    abstract getStates(
        countryCode: string | null,
        language: string,
    ): Observable<StateApiData>;
}
